<div class="flex w-full">
  @for (tab of tabs(); track tab.id) {
    <div
      class="flex flex-1 text-[0.8125rem] md:text-[1.125rem]/[160%] font-light border-b border-solid py-3 justify-center cursor-pointer tab"
      [class.font-medium]="tab.id === selectedTab()"
      [class.border-b-2]="tab.id === selectedTab()"
      [class.selected-tab]="tab.id === selectedTab()"
      (click)="onTabClick(tab.id)"
    >
      {{ tab.label | translate }}
    </div>
  }
</div>
